import PropTypes, { number } from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";

//Import Breadcrumb

//i18n
import { withTranslation } from "react-i18next";
import { getAllEvents, getAllOrganizer, getBookingByEventId, getForumBySlug } from "api";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import TableContainer from "../../../components/Common/TableContainer";
import moment from "moment";

import { AgGridReact } from 'ag-grid-react';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { filter } from "lodash";

const pagination = true;
const paginationPageSize = 500;
const paginationPageSizeSelector = [200, 500, 1000];
const RevenueReport = props => {
    //meta title
    document.title = "Revenue Report | EventoX";
    const [eventList, setEventList] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [bookingList, setBookingList] = useState([])
    const [gridParams, setGridParams] = useState(null)
    const [gridApi, setGridApi] = useState(null);
    const gridApiRef = useRef(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");


    const [reports, setReports] = useState([
            { title: "Total Collected Amount", iconClass: "bx-copy-alt", description: 0,col:3 },
            { title: "Total Ticket Sales", iconClass: "bx-copy-alt", description: 0,col:3 },
            { title: "Total Discount", iconClass: "bx-copy-alt", description: 0,col:3 },
            { title: "Total Booking", iconClass: "bx-archive-in", description: 0,col:3 },
        


            { title: "Organizer Revenue", iconClass: "bx-purchase-tag-alt", description: 0, col:4},
            { title: "Eventox Revenue", iconClass: "bx-purchase-tag-alt", description: 0, col:4},
            { title: "Strip Payment Fee", iconClass: "bx-purchase-tag-alt", description: 0, col:4},



            


    ])

    useEffect(() => {
        fetchAll()
    }, [])
    
    useEffect(() => {
        if (selectedEvent) {
          fetchBookingByEvent(selectedEvent);
        }
      }, [fromDate, toDate, selectedEvent]);
      
    const fetchAll = async () => {
        try {

            const respAllEvent = await getAllEvents();
            const eventOptions = respAllEvent.map((item) => {
                return {
                    value: item.eventId,
                    label: item.eventName,
                    ticketFee: item.ticketFee,
                    processingFee:item.processingFee,
                    ticketFee:item.ticketFee,
                }
            })
            setEventList(eventOptions);





        } catch (error) {
            console.log(error);
        }
    }

    const fetchBookingByEvent = async (data) => {
        const { value,ticketFee,processingFee } = data;
        const getBookingResp = await getBookingByEventId(value)
        const filteredBooking = getBookingResp.filter((item) => {
            const bookingDate = moment(item.createdAt);
            const from = fromDate ? moment(fromDate).startOf('day') : null;
            const to = toDate ? moment(toDate).endOf('day') : null;
          
            return (!from || bookingDate.isSameOrAfter(from)) &&
                   (!to || bookingDate.isSameOrBefore(to));
          });
          
        let summaryData=[];
        let totalEventoxFee=0;
        let totalStripeFee=0;   
        let totalTicketAmount=0;
        let totalDiscountAmount=0;
        let totalTicketSold=0;
        let totalGrandTotal=0;
        let totalSuccessBooking=0;
        let totalOrganizerRevenue=0;
        //if processingFee and ticketFee is 0 then fee collected from organizer else fee collected from user
        let feeCollectedFromOrganizer=processingFee===0&&ticketFee===0?true:false;
       
        
        filteredBooking.forEach(item => {
            if(item.bookedBy === '0'&&item.bookingStatus === 'confirmed'){
               
                let stripefee=0;
                let eventoxRevenue=0;
                let organizerRevenue=0;

                const grandTotal = item.grandTotal;
                const ticketAmount = item.totalTicketAmount;
                const discountAmount = item.discountAmount?item.discountAmount:0;
                const ticketCount=item.totalTicketCount;
                // if(feeCollectedFromOrganizer){
                //     stripefee=((grandTotal/100)*2.7)+0.30;
                //     const ticketFee=ticketCount*0.5;
                //     const ourFee=((grandTotal/100)*2.5)+(ticketFee);
                //     if(Number(ticketCount)===1){
                //         eventoxRevenue=0;
                //     }else{
                //         eventoxRevenue=Number(ourFee)-Number(stripefee);
                //     }
                    
                //     organizerRevenue=grandTotal-stripefee-eventoxRevenue-discountAmount;
                  
                // }else{
                if(item.stripeRevenue===null){
                    stripefee=((grandTotal/100)*2.7)+0.30;
                }else{
                    stripefee=item.stripeRevenue;
                }
                if(item.eventoxRevenue===null){
                    eventoxRevenue=grandTotal-stripefee-ticketAmount-discountAmount;
                }else{
                    eventoxRevenue=item.eventoxRevenue;
                }
                if(item.organizerRevenue===null){
                    organizerRevenue=(ticketAmount-stripefee-eventoxRevenue-discountAmount);
                }else{
                    organizerRevenue=item.organizerRevenue;
                }
            // }

                totalStripeFee+=Number(stripefee);
                totalEventoxFee+=Number(eventoxRevenue);
                totalTicketAmount+=Number(ticketAmount);
                totalDiscountAmount+=Number(discountAmount);
                totalTicketSold+=item?.totalTicketCount;
                totalGrandTotal+=Number(grandTotal);
                totalOrganizerRevenue+=Number(organizerRevenue);
                totalSuccessBooking+=1;


                summaryData.push({
                    userDetails:{
                        name:item?.bookingObject?.primaryContactDetails?.firstName + ' ' + item?.bookingObject?.primaryContactDetails?.lastName,
                        email:item?.bookingObject?.primaryContactDetails?.email,
                        phone:item?.bookingObject?.primaryContactDetails?.phoneNo,
                    },
                    ticketDetails:{
                        ticketName:item?.TicketType?.ticketType,
                        ticketPrice:item?.TicketType?.price,
                        
                    },
                    bookingNo:item?.bookingNo,
                    ticketSold:item?.totalTicketCount,
                    totalTicketAmount:item?.totalTicketAmount,
                    discount:`$${discountAmount.toFixed(2)}`,
                    stripeFee:`$${stripefee?stripefee.toFixed(2):0}`,
                    eventoxRevenue:`$${eventoxRevenue?eventoxRevenue.toFixed(2):0}`,
                    organizerRevenue:`$${organizerRevenue?organizerRevenue.toFixed(2):0}`,
                    grandTotal:`$${grandTotal.toFixed(2)}`,
                    createdAt:moment(item.createdAt).format('DD-MMM-YYYY HH:mm:ss')
                })  
            }
        })
        



        setBookingList(summaryData)
        console.log("🚀 ~ fetchBookingByEvent ~ summaryData:", summaryData)
        setReports([
            { title: "Total Collected Amount", iconClass: "bx-copy-alt", description: `$${totalGrandTotal.toFixed(2)}`,col:3 },
            { title: "Total Discount", iconClass: "bx-copy-alt", description: `$${totalDiscountAmount.toFixed(2)}`,col:3 },
            { title: "Total Success Booking", iconClass: "bx-archive-in", description: totalSuccessBooking,col:3 },


            { title: "Organizer Revenue", iconClass: "bx-purchase-tag-alt", description: `$${totalOrganizerRevenue.toFixed(2)}`, col:4},
            { title: "Eventox Revenue", iconClass: "bx-purchase-tag-alt", description: `$${totalEventoxFee.toFixed(2)}`, col:4},
            { title: "Strip Payment Fee", iconClass: "bx-purchase-tag-alt", description: `$${totalStripeFee.toFixed(2)}`, col:4},
            


           

        ])


    }
    const columns =  [
            {
                headerName: 'Booking No',
                field: 'bookingNo',
                filter: true
            },
            {
                headerName: 'Name',
                field: 'userDetails.name',
                

            },
            {
                headerName: 'Email',
                field: 'userDetails.email',
                filter: true
            },
            {
                headerName: 'Phone',
                field: 'userDetails.phone',
                filter: true
            },
            // {
            //     headerName: 'Ticket Details',
            //     field: 'ticketDetails',
            //     cellRenderer: params => {
            //         return <div>
            //             <p>{`${params.data.ticketDetails.ticketName} - $${params.data.ticketDetails.ticketPrice}`}</p><br/>
                      
            //         </div>
            //     },
            //     filter: true

            // },
            {
                headerName: 'Ticket Sold',
                field: 'ticketSold',
                cellRenderer: params => {
                    return <div>
                        <p>{`${params.data.ticketSold} tickets sold`}</p>
                    </div>
                },
                filter: true,
                
            },
            {
                headerName: 'Total Ticket Amount',
                field: 'totalTicketAmount',
                filter: true,
                
            },
            {
                headerName: 'Discount Amount',
                field: 'discount',
                filter: true,
                

            },
           
            {
                headerName: 'Stripe Fee',
                field: 'stripeFee',
                filter: true,

            },
            {
                headerName: 'Eventox Revenue',
                field: 'eventoxRevenue',
                filter: true,

            },
            {
                headerName: 'Organizer Revenue',
                field: 'organizerRevenue',
                filter: true,

            },
            {
                headerName: 'Grand Total',
                field: 'grandTotal',
                filter: true,

            },


           
            {
                headerName: 'Created At',
                field: 'createdAt',
                filter: true,
                sortable: true,

            },



        ]



    const onGridReady = (params) => {
        gridApiRef.current = params.api // <= assigned gridApi value on Grid ready 
        setGridParams(params)
        setGridApi(params.api);

    }
    const getContextMenuItems = (params) => {
        const result = [
          'copy',
          'copyWithHeaders',
          'paste',
          'separator',
          {
            name: 'Export All',
            action: () => {
              params.api.exportDataAsExcel();
            },
            icon: '<i class="fas fa-file-excel"></i>', // Optional: add an icon for the menu item
          },
        ];
        return result;
      };
      const downloadCSV = () => {
        if (bookingList.length > 0) {
            let csvContent = '';
    
            // Report summary
            if (reports.length > 0) {
                csvContent += 'Title,Value\n';
                reports.forEach(r => {
                    csvContent += `"${r.title}","${r.description}"\n`;
                });
                csvContent += '\n';
            }
    
            // Booking revenue table
            const headers = [
                'Booking No','Name', 'Email', 'Phone', 'Ticket Name', 'Ticket Price', 'Ticket Sold',
                'Discount Amount', 'Stripe Fee', 'Eventox Revenue', 'Organizer Revenue', 'Grand Total', 'Booking Date'
            ];
            csvContent += headers.join(',') + '\n';
    
            bookingList.forEach(row => {
                const values = [
                    row.bookingNo || '',
                    row.userDetails?.name || '',
                    row.userDetails?.email || '',
                    row.userDetails?.phone || '',
                    row.ticketDetails?.ticketName || '',
                    row.ticketDetails?.ticketPrice || '',
                    row.ticketSold,
                    row.discount,
                    row.stripeFee,
                    row.eventoxRevenue,
                    row.organizerRevenue,
                    row.grandTotal,
                    moment(row.createdAt).format('DD-MMM-YYYY HH:mm:ss')
                ];
                csvContent += values.map(v => `"${v}"`).join(',') + '\n';
            });
    
            // Download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'revenue_report.csv';
            link.click();
        }
    };
    
const downloadPDF = () => {
    if (bookingList.length > 0) {
        const doc = new jsPDF('l', 'mm', 'a4');

        // Report Summary Table
        const reportHeaders = ['Title', 'Value'];
        const reportData = reports.map(r => [
            r.title,
            typeof r.description === 'number' ? r.description : r.description?.toString()
        ]);

        doc.autoTable({
            head: [reportHeaders],
            body: reportData,
            startY: 10,
            theme: 'striped',
            styles: { fontSize: 10,cellPadding: 2 },
            
        });

        const finalY = doc.lastAutoTable.finalY + 10;

        // Booking Revenue Table
        const headers = [
            'Booking No','Name', 'Email', 'Phone', 'Ticket Name', 'Ticket Price', 'Ticket Sold',
            'Discount Amount', 'Stripe Fee', 'Eventox Revenue', 'Organizer Revenue', 'Grand Total', 'Booking Date'
        ];

        const data = bookingList.map(row => [
            row.bookingNo || '',
            row.userDetails?.name || '',
            row.userDetails?.email || '',
            row.userDetails?.phone || '',
            row.ticketDetails?.ticketName || '',
            row.ticketDetails?.ticketPrice || '',
            row.ticketSold,
            row.discount,
            row.stripeFee,
            row.eventoxRevenue,
            row.organizerRevenue,
            row.grandTotal,
            moment(row.createdAt).format('DD-MMM-YYYY HH:mm:ss')
        ]);

        doc.autoTable({
            head: [headers],
            body: data,
            startY: finalY,
            theme: 'striped',
            styles: { fontSize: 10, cellPadding: 2 },
            margin: { left: 10, right: 10 },
            tableWidth: 'auto'
        });

        doc.save('revenue_report.pdf');
    }
};



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Dashboards")}
                        breadcrumbItem={props.t("Revenue Report")}
                    />

                    <Row>
                        <Col xl="12">
                            <Row>
                                {(reports || [])?.map((report, key) => (
                                    <Col md={report.col} key={"_col_" + key}>
                                        <Card className="mini-stats-wid">
                                            <CardBody>
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted fw-medium">
                                                            {report.title}
                                                        </p>
                                                        <h4 className="mb-0">{report.description}</h4>
                                                    </div>
                                                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                                                        <span className="avatar-title rounded-circle bg-primary">
                                                            <i className={"bx " + report.iconClass + " font-size-24"}></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="12">

                            <Card>
                                <CardBody>
                                    <Row className="mb-3">
                                      <Col xl="5">
                                        <Select
                                          value={selectedEvent}
                                          placeholder="Select Event"
                                           onChange={(data) => {
                                          setSelectedEvent(data);
                                        fetchBookingByEvent(data);  
                                              }}
                                          options={eventList}
                                          width="100%"
                                          className="select2-selection"
                                        />
                                      </Col>
                                      <Col xl="2">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="form-control"
                                />
                                </Col>

                                <Col xl="2">
                                <label>To Date</label>
                                <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="form-control"
                                />
                                </Col>

                                      <Col >
                <div className="text-lg-end mt-3 mt-lg-0">
                  <UncontrolledDropdown>
                    <DropdownToggle color="primary" type="button">
                      <i className="bx bx-download me-2"></i> Export <i className="mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem href="#" onClick={downloadCSV}>Export CSV</DropdownItem>
                      <DropdownItem href="#" onClick={downloadPDF}>Export PDF</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
                                      
                                    </Row>
                                    <Row>
                                        <div style={{
                                            height: '500px',
                                            width: '100%'
                                        }} className="ag-theme-alpine">
                                            <AgGridReact
                                                columnDefs={columns}
                                                rowData={bookingList}
                                                onGridReady={onGridReady}
                                                // getRowId={({ data }) => data?.bookingNo?.toString()}
                                                ref={gridApiRef}
                                                defaultColDef={{
                                                    floatingFilter: true,
                                                    filter: 'agTextColumnFilter',
                                                    sortable: true,
                                                    resizable: true,
                                                    enableRowGroup: true,
                                                }}
                                                getContextMenuItems={getContextMenuItems}
                                                sideBar={{ toolPanels: ['columns', 'filters'] }}
                                                rowGroupPanelShow="always"
                                                pagination
                                                paginationPageSize={paginationPageSize}
                                                paginationPageSizeSelector={paginationPageSizeSelector}
                                                suppressRowClickSelection={true}
                                               
                                               

                                            />
                                        </div>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};



export default withTranslation()(RevenueReport);

